import { ColDef, ICellRendererParams } from 'ag-grid-community'
import { LinkButton, ValueCountPoint } from 'components/core-v2'
import { CurrencyCell } from 'components/core-v2/organisms'
import cellsClasses from 'components/core-v2/organisms/tables/cells.module.scss'
import { useState } from 'react'

const NameCellWithModal = ({
  ModalComponent,
  name
}: Pick<ValueCountPoint, 'ModalComponent' | 'name'>) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <LinkButton underline className={cellsClasses.ellipsis} onClick={() => setIsOpen(true)}>
        {name}
      </LinkButton>
      {ModalComponent && <ModalComponent isOpen={isOpen} onClose={() => setIsOpen(false)} />}
    </>
  )
}

const NameCell = ({ data: { ModalComponent, name } }: ICellRendererParams<ValueCountPoint>) =>
  ModalComponent ? <NameCellWithModal ModalComponent={ModalComponent} name={name} /> : name

export const COLUMN_DEFS: ColDef[] = [
  {
    headerName: 'Name',
    field: 'name',
    minWidth: 130,
    flex: 0.6,
    cellRenderer: NameCell
  },
  {
    headerName: 'Trades',
    field: 'trades',
    minWidth: 110,
    flex: 0.2,
    type: 'rightAligned'
  },
  {
    headerName: 'Value',
    field: 'value',
    minWidth: 110,
    flex: 0.2,
    type: 'rightAligned',
    sort: 'desc',
    cellRenderer: CurrencyCell({ fieldName: 'value' })
  }
]

export const DEFAULT_COLUMN_DEFS: ColDef = {
  sortable: true,
  unSortIcon: true
}

export const getTableRowData = (data: ValueCountPoint[]) =>
  data.reduce((rowData, point) => {
    // Inner ring
    if (point.parent === '0') {
      if (point.count) {
        rowData.push({ trades: point.count, ...point })
      } else {
        const children = data.reduce(
          (acc, innerPoint) => {
            if (innerPoint.parent === point.id) {
              acc.count++
              acc.value += innerPoint.value
            }
            return acc
          },
          { count: 0, value: 0 }
        )
        rowData.push({ trades: children.count, value: children.value, ...point })
      }
    }
    return rowData
  }, [])
